import { render } from "./TrazAnalysis.vue?vue&type=template&id=10061ce7&scoped=true"
import script from "./TrazAnalysis.vue?vue&type=script&lang=js"
export * from "./TrazAnalysis.vue?vue&type=script&lang=js"

import "./TrazAnalysis.vue?vue&type=style&index=0&id=10061ce7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10061ce7"]])

export default __exports__